import React, { useState } from 'react';
import { injectIntl } from "react-intl";
import LoginFrame from '../components/loginFrame';
import UserName from "../components/userName";
import { getDomainConfig } from "../domainconfigs/domainconfig";


const username = injectIntl(({ history }) => {
  const [hasError, setError] = useState(false);

  const domainConfig = getDomainConfig(window.location.host);

  const handleNextOrEnter = (username) => {
    if (username && username.length > 0) {
      history.push(`/login/${username}`);
    } else {
      setError(true);
    }
  };

  const onFocus = () => {
    if (hasError) {
      setError(false);
    }
  };

  return (
    <LoginFrame appName={domainConfig.appName}
      companyName={domainConfig.companyName}
      imageSource={domainConfig.appLogo}
      isChangePasswordScreen={false}
      showAppInfo
      hideTermsPolicy={true}>
      <UserName cbNext={handleNextOrEnter} cbOnEnter={handleNextOrEnter} cbOnFocus={onFocus} hasError={hasError} />
    </LoginFrame>
  );
});

export default username;